import { useHistory } from "react-router";

function EventMonth({ event }) {
  const history = useHistory();

  let cancelledEvent = event && event.status == "canceled" ? true : false;

  return (
    <div
      onClick={() => history.push("/my-appointments/" + event.id)}
      className="border-l-4 border-indigo-600 pl-1 flex items-center overflow-auto shadow-2xl"
      style={{ boxShadow: "5px 10px #888888" }}
    >
      <div
        style={{ color: "grey" }}
        className="mr-1 rounded-full h-30 w-30 pr-1"
      >
        <img
          src={ event.profile_pic ? event.profile_pic : "/avator.png"}
          height={25}
          width={25}
          alt="avator"
          className="rounded-full"
        />
      </div>
      <div>
        <div
          className={`font-bold text-base ${
            cancelledEvent ? "line-through text-red-500" : "text-secondary "
          }`}
          style={{ fontSize: 14, width: 30 }}
        >
          {event.name}
        </div>
        {/* <div>{event.event.treatment_type}</div> */}
        <div
          className={`text-xs text-gray-400 font-bold -mt-1.5 ${
            cancelledEvent ? "line-through text-red-500" : "text-xs"
          }`}
        >
          {new Date(event.start).toLocaleTimeString("en-us", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </div>
    </div>
  );
}

export default EventMonth;
